import apiService from 'src/services/ApiCallService';
import ErrorUtils from 'src/utils/ErrorUtils';
import { AuditEvent, FieldChanges, GetAuditEventChangesResponse, GetAuditEventsResponse } from 'src/models/AuditEvents';

export default class AuditService {
  async getAuditEvents(registrationNumber: string, pageSize?: number, previousPageToken?: string) {
    let auditEvents: AuditEvent[] | undefined = undefined;
    let nextPageToken: string | undefined = undefined;
    let error: string | undefined = undefined;

    try {
      const response = await apiService.getAuditEvents(registrationNumber, pageSize, previousPageToken);
      const data: GetAuditEventsResponse = (await response.json()) as GetAuditEventsResponse;
      auditEvents = data.auditEvents;
      nextPageToken = data.nextToken;
    } catch (ex) {
      error = ErrorUtils.getMessage(ex);
    }

    return {
      auditEvents: auditEvents,
      nextToken: nextPageToken,
      error: error,
    };
  }

  async getAuditEventChanges(registrationNumber: string, lastUpdatedDateTime: string) {
    let changes: FieldChanges | undefined = undefined;
    let error: string | undefined = undefined;

    try {
      const response = await apiService.getAuditEventChanges(registrationNumber, lastUpdatedDateTime);
      const data: GetAuditEventChangesResponse = (await response.json()) as GetAuditEventChangesResponse;
      changes = data.fieldChanges;
    } catch (ex) {
      error = ErrorUtils.getMessage(ex);
    }

    return {
      changes: changes,
      error: error,
    };
  }
}
